import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private activeRequests = 0;

  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip progress bar for certain requests if needed (e.g., polling, SSE)
    // You can add conditions here to exclude specific endpoints
    const shouldSkip = req.url.includes('/blob/') || req.url.includes('/download');
    
    if (!shouldSkip) {
      if (this.activeRequests === 0) {
        // Use setTimeout to defer the change to the next tick, avoiding change detection errors
        setTimeout(() => {
          this.loaderService.show();
        }, 0);
      }
      this.activeRequests++;
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (!shouldSkip) {
          this.activeRequests--;
          if (this.activeRequests === 0) {
            // Use setTimeout to defer the change to the next tick, avoiding change detection errors
            setTimeout(() => {
              this.loaderService.hide();
            }, 0);
          }
        }
      })
    );
  }
}

